export const ACTION_SIGN_IN = 'ACTION_SIGN_IN';
export const ACTION_SIGN_OUT = 'ACTION_SIGN_OUT';
export const ACTION_GET_USER = 'ACTION_GET_USER';
export const ACTION_SET_AUTH = 'ACTION_SET_AUTH';
export const ACTION_REMOVE_AUTH = 'ACTION_REMOVE_AUTH';
